import React from 'react'
import { BsChevronRight } from 'react-icons/bs'

const ViewMoreBtn = ({ content = <BsChevronRight  fontWeight={600}/>,className,  click = () => null }) => {
    return (
        <div className={'w-[fit] text-center btn cursor-pointer py-1 px-1 !bg-[inherit] rounded border'+className} onClick={click}>
            {content}
        </div>
    )
}

export default ViewMoreBtn